import { render, staticRenderFns } from "./pension-unit-selections.vue?vue&type=template&id=186c6d45&scoped=true&"
import script from "./pension-unit-selections.vue?vue&type=script&lang=ts&"
export * from "./pension-unit-selections.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186c6d45",
  null
  
)

export default component.exports